document.addEventListener("DOMContentLoaded", function () {

  const dateInput = document.querySelector('#pickup_date');
  const timeSelect = document.querySelector('#pickup_time');

  if (!dateInput || !timeSelect) {
    return;
  }


  // Empêche les retraits trop proches (48h)
  let minimumDate = new Date();
  minimumDate.setDate(minimumDate.getDate() + 2);

  dateInput.min = minimumDate.toISOString().split("T")[0];


  function afficherHoraires() {

    timeSelect.innerHTML = '<option value="">Choisir une heure</option>';

    let dateChoisie = new Date(dateInput.value);
    let jour = dateChoisie.getDay();

    let horaires = [];


    // Vendredi
    if (jour === 5) {
      horaires = [
        "15h00",
        "15h30",
        "16h00",
        "16h30",
        "17h00",
        "17h30",
        "18h00",
        "18h30"
      ];
    }


    // Samedi
    if (jour === 6) {
      horaires = [
        "08h45",
        "09h15",
        "09h45",
        "10h15",
        "10h45",
        "11h15",
        "11h45",
        "12h15",
        "15h00",
        "15h30",
        "16h00",
        "16h30",
        "17h00",
        "17h30",
        "18h00",
        "18h30"
      ];
    }


    // Dimanche
    if (jour === 0) {
      horaires = [
        "08h30",
        "09h00",
        "09h30",
        "10h00",
        "10h30",
        "11h00",
        "11h30",
        "12h00",
        "12h30"
      ];
    }


    horaires.forEach(function(heure){

      let option = document.createElement("option");

      option.value = heure;
      option.textContent = heure;

      timeSelect.appendChild(option);

    });

  }



  dateInput.addEventListener("change", function(){

    let date = new Date(this.value);
    let jour = date.getDay();


    // Bloque lundi à jeudi
    if (jour !== 0 && jour !== 5 && jour !== 6) {

      alert("Les retraits sont possibles uniquement vendredi, samedi et dimanche.");

      this.value = "";

      timeSelect.innerHTML =
      '<option value="">Choisir une heure</option>';

      return;

    }


    afficherHoraires();

  });


});